import React from 'react';
import { Link } from 'react-router-dom';
import { SeoManager } from '../seo';
import { buildCanonicalUrl } from '../seo/siteConfig';
import { buildWebPageSchema } from '../seo/structuredData';
import EmailLink from '../components/EmailLink';
import blogData from '../blog/articles';
import BlogByline from '../components/BlogByline';
import '../styles/Blog.css';

export default function BlogPage() {
  const { index, articles } = blogData;
  const canonicalUrl = buildCanonicalUrl(index.path);

  return (
    <main className="blog-page">
      <SeoManager
        title={index.title}
        description={index.description}
        keywords={index.keywords}
        path={index.path}
        structuredData={buildWebPageSchema({
          title: index.title,
          description: index.description,
          url: canonicalUrl,
        })}
      />
      <div className="container">
        <h1>Blog</h1>
        <p className="blog-lede">
          Guides for each game on Type Click Tests. Use these URLs when you write about
          the games, teach a class, or swap a backlink — each article is a separate,
          crawlable page with a link through to play.
        </p>
        <ul className="blog-list">
          {articles.map((article) => (
            <li key={article.slug}>
              <h2>
                <Link to={`/blog/${article.slug}/`}>{article.title}</Link>
              </h2>
              <BlogByline datePublished={article.datePublished} compact />
              <p>{article.description}</p>
              <Link to={`/blog/${article.slug}/`}>Read the guide</Link>
              {' · '}
              <Link to={article.gamePath}>Play {article.gameName}</Link>
            </li>
          ))}
        </ul>
        <h2>Link exchange</h2>
        <p>
          If you run a typing, gaming, or education site and want to exchange a
          contextual link, contact us at <EmailLink />. Point at a specific article
          or game page, not a generic homepage dump.
        </p>
      </div>
    </main>
  );
}
